/*
 * Model for the Menu Bar
 */

define(["backbone", "messaging/messenger"], function (Backbone, Messenger) {
  var MenuItemModel = Backbone.Model.extend({
    defaults: {
      selected: false,
      hidden: false,
    },
  });

  //request to get menu bar items
  Messenger.reqres.setHandler("menu:bar:items", function () {
    //handle optional tasks item
    var isAuthor = Messenger.reqres.request("user:is:author");
    if (isAuthor) {
      var menuItems = [new MenuItemModel({ name: "topics", label: "menuBar.topics" })];
      if (Messenger.reqres.request("can:view:learnerTab")) {
        menuItems.push(new MenuItemModel({ name: "learner", label: "menuBar.learner" }));
      }
      if (Messenger.reqres.request("can:view:contentTab")) {
        menuItems.push(new MenuItemModel({ name: "contents", label: "menuBar.content" }));
      }
      if (Messenger.reqres.request("can:view:substitutionsTab")) {
        menuItems.push(
          new MenuItemModel({ name: "substitutions", label: "menuBar.substitutions" }),
        );
      }
      menuItems = menuItems.concat([
        new MenuItemModel({ name: "actions", label: "menuBar.actions", hidden: true }),
        new MenuItemModel({ name: "reports", label: "menuBar.reports" }),
        new MenuItemModel({ name: "tasks", label: "menuBar.tasks", hidden: true }),
      ]);
      return new Backbone.Collection(menuItems);
    } else if (
      Messenger.reqres.request("user:is:reviewer") &&
      Messenger.reqres.request("user:is:reporter")
    ) {
      //only show reviews and reports
      return new Backbone.Collection([
        new MenuItemModel({ name: "tasks", label: "menuBar.tasks", hidden: true }),
        new MenuItemModel({ name: "reports", label: "menuBar.reports" }),
      ]);
    } else if (Messenger.reqres.request("user:is:reviewer")) {
      //only show reviews
      return new Backbone.Collection([
        new MenuItemModel({ name: "tasks", label: "menuBar.tasks", hidden: true }),
        //new MenuItemModel({name:"tasks", label:"menuBar.tasks"})
      ]);
    } else {
      return new Backbone.Collection([
        new MenuItemModel({ name: "reports", label: "menuBar.reports" }), //,
        //new MenuItemModel({name:"tasks", label:"menuBar.tasks"})
      ]);
    }
  });
});
